module.exports = __webpack_public_path__ + "static/media/CountryOfOrigin.13422b0c.jpg";